import { useMemo } from "react";
import { Stack } from "@mui/material";
import MapDisplay from "../../../components/atoms/MapDisplay";

const getInitials = (name) => {
  if (typeof name !== "string" || !name) return "";

  // 1. Tomar solo la parte antes del @ (si es un correo)
  const userPart = name.split("@")[0];

  // 2. Dividir por separadores comunes en correos (punto, guion bajo, guion medio, espacio)
  const parts = userPart.split(/[._\-\s]+/);
  let initials = "";

  if (parts.length > 1 && parts[0] && parts[parts.length - 1]) {
    // Caso "julio.perez" -> "JP"
    initials = parts[0][0] + parts[parts.length - 1][0];
  } else if (parts[0] && parts[0].length > 1) {
    // Caso "julio" -> "JU"
    initials = parts[0][0] + parts[0][1];
  } else if (parts[0]) {
    // Caso extremo "j" -> "J"
    initials = parts[0][0];
  }

  return initials.toUpperCase();
};

function ChekInMaps({ selectedAgent = "", users = [], permissions = {} }) {
  // Transformar datos con useMemo para evitar estado intermedio null (causa parpadeo)
  const checkInMarkers = useMemo(() => {
    if (!selectedAgent || users.length === 0) return [];

    const matchingUsers =
      selectedAgent === "00001"
        ? users.filter((u) => u.location)
        : users.filter((u) => u.id === selectedAgent && u.location);

    if (matchingUsers.length === 0) return [];

    return matchingUsers.map((user) => {
      const [lat, lng] = user.location.split(",").map(Number);

      const fullDate = new Date(user.date);
      const formattedDate = fullDate.toLocaleDateString("es-MX", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      });

      const formattedTime = fullDate.toLocaleTimeString("es-MX", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
      });

      return {
        ...user,
        lat,
        lng,
        date: formattedDate,
        time: formattedTime,
        Initials: getInitials(user.name),
      };
    });
  }, [selectedAgent, users]);

  return (
    <Stack>
      <MapDisplay
        receive="CheckIn"
        checkInMarkers={checkInMarkers}
        permissions={permissions}
      />
    </Stack>
  );
}

export default ChekInMaps;
